module.exports = __webpack_public_path__ + "il.46e209053a1476b4e433.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/il.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/il.svg
// module chunks = styles